










import { Component, Vue, Mixins } from 'vue-property-decorator'
import Visualization from './Visualization.vue'

@Component
export default class Canvas extends Mixins(Visualization) {
  /**
   * Render the canvas.
   */
  public renderCanvas() {}

  /**
   * Reset the canvas.
   */
  public reset() {
    const ratio = window.devicePixelRatio || 1
    this.canvas.style.height = this.height + 'px'
    this.canvas.style.width = this.width + 'px'
    this.canvas.style.maxHeight = this.height + 'px'
    this.canvas.style.maxWidth = this.width + 'px'
    this.canvas.height = this.height * ratio
    this.canvas.width = this.width * ratio
    this.context.scale(ratio, ratio)
    this.context.clearRect(0, 0, this.width, this.height)
  }
  /**
   * Reset and render.
   */
  public resetAndRender() {
    this.reset()
    this.renderCanvas()
  }

  /**
   * On mounted hook.
   */
  mounted() {
    window.addEventListener('resize', this.resetAndRender.bind(this))
    this.resetAndRender()
  }
}
